export const CUSTOMER_ID = 'customerid';
